import React from "react";
import { CustomerSummary as CustomerSummaryType } from "./dashboardType";

interface Props {
  data: CustomerSummaryType;
}

const CustomerSummary: React.FC<Props> = ({
  data,
}) => {
  const items = [
    [
      "Total Customers",
      data.Total_Customers,
    ],
    [
      "Active Customers",
      data.Active_Customers,
    ],
    [
      "New Customers",
      data.New_Customers,
    ],
    [
      "Existing Customers",
      data.Existing_Customers,
    ],
    [
      "Payment Customers",
      data.Payment_Customers,
    ],
  ];

  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Customers
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        {items.map(
          ([label, value]) => (
            <div
              key={String(label)}
              className="rounded-lg bg-gray-50 p-4"
            >
              <p className="text-sm text-gray-500">
                {label}
              </p>

              <p className="mt-1 text-xl font-bold">
                {value}
              </p>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default CustomerSummary;